import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Breakdown } from '@core/models/breakdown/breakdown.interface';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class HotelsService {
  private API_PATH = `/hotels/results/api`;

  constructor(private http: HttpClient) {}

  public getHotels(params): Observable<any> {
    return this.http
      .get(`${this.API_PATH}/${params.isLanding ? 'landing' : 'search'}/${params.id}`, { params })
      .pipe(
        map((res: any) => res),
        catchError((err) => of(err)),
      );
  }

  public getAll(params: any): Observable<any> {
    return this.http.get(`${this.API_PATH}/search/allResult/${params.id}`, { params }).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((err) => of(err)),
    );
  }

  public getRecommendedHotels(params: any): Observable<any> {
    return this.http
      .get(`${this.API_PATH}/search/recommended-hotels/${params.hotelId}`, { params })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((err) => of(err)),
      );
  }

  public submitP13nEventLanding(entityId): Observable<any> {
    return this.http.post(`${this.API_PATH}/landing/p13n/event`, { entityId });
  }

  public setTrivagoInfo(params) {
    if (this.isLocalStorageAvailable()) {
      params.trv_reference
        ? localStorage.setItem('trv_reference', params.trv_reference)
        : localStorage.removeItem('trv_reference');
      params.utm_medium
        ? localStorage.setItem('utm_medium', params.utm_medium)
        : localStorage.removeItem('utm_medium');
    }
  }

  public getHotelBreakdown(rate_id?: string, currencyCode?: string): Observable<Breakdown> {
    const bodyReq = {
      rateId: rate_id,
      currencyCode,
    };
    return this.http.post(`${this.API_PATH}/price/breakdown`, bodyReq).pipe(
      map((res: any) => res),
      catchError((err) => of(err)),
    );
  }

  isLocalStorageAvailable() {
    try {
      const testKey = '__test__';
      localStorage.setItem(testKey, testKey);
      localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }
}
